import { render, staticRenderFns } from "./SelectPropertie.vue?vue&type=template&id=2f0412a6&scoped=true&"
import script from "./SelectPropertie.vue?vue&type=script&lang=js&"
export * from "./SelectPropertie.vue?vue&type=script&lang=js&"
import style0 from "./SelectPropertie.vue?vue&type=style&index=0&id=2f0412a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0412a6",
  null
  
)

export default component.exports